export default __webpack_public_path__ + "static/media/pokeCreated1.56fe9ff9.gif";